import { render, staticRenderFns } from "./OnlineUsers.vue?vue&type=template&id=4a224a53&"
import script from "./OnlineUsers.vue?vue&type=script&lang=js&"
export * from "./OnlineUsers.vue?vue&type=script&lang=js&"
import style0 from "./OnlineUsers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VAvatar,VBadge,VCard,VCardText,VCardTitle})
